import { lazyNamed } from "src/utils/lazy-named";

import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";

import { EntitledRoute } from "src/components/router/entitled-route";

const MetricsLayout = lazyNamed(() => import("./layout"), "MetricsLayout");
const metricsImport = () => import("./metrics");
const Metrics = lazyNamed(metricsImport, "Metrics");

export const preloads: RoutePreload[] = [["/metrics", metricsImport]];
const CreateMetric = lazyNamed(
  () => import("src/pages/metrics/create-metric"),
  "CreateMetric",
);
const Metric = lazyNamed(() => import("src/pages/metrics/metric"), "Metric");
const AttributionMethods = lazyNamed(
  () => import("./attribution-methods/attribution-methods"),
  "AttributionMethods",
);
const CreateAttributionMethod = lazyNamed(
  () => import("./attribution-methods/create"),
  "CreateAttributionMethod",
);
const ViewAttributionMethod = lazyNamed(
  () => import("./attribution-methods/view"),
  "ViewAttributionMethod",
);

export const routes: Array<RouteObject> = [
  {
    path: "metrics",
    element: <EntitledRoute entitlement="analytics" redirect="/" />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        path: "new",
        element: <CreateMetric />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: ":metric_id",
        element: <Metric />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "attributions/new",
        element: <CreateAttributionMethod />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "attributions/:attribution_method_id",
        element: <ViewAttributionMethod />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "",
        element: <MetricsLayout />,
        spacesAccess: "hidden-from-limited-view",
        children: [
          {
            path: "attributions",
            element: (
              <EntitledRoute redirect="/" entitlement="campaigns">
                <AttributionMethods />
              </EntitledRoute>
            ),
            spacesAccess: "hidden-from-limited-view",
          },
          {
            index: true,
            element: <Metrics />,
            spacesAccess: "hidden-from-limited-view",
          },
        ],
      },
    ],
  },
];
